export const appWhitelist = [
  ['setToken'],
  ['logout'],
  ['profile'],
  ['interviewRecord'],
  ['search'],
  ['advanceConfirmAnswer'],
  ['publicRecruitmentRecord'],
  ['publicRecruitment'],
  ['publicRecruitmentApplication'],
  ['publicRecruitmentAdvanceConfirmAnswer'],
  ['resultManagementSearch'],
  ['resultManagementDetail'],
  ['resultManagementRecord'],
  ['transferHopeRegister'],
  ['transferHopeRecord'],
  ['transferHopeSearch'],
  ['transferHopeDetail'],
  ['minutesRegister'],
  ['minutesSearch'],
  ['minutesDetail'],
  ['minutesEdit'],
  ['minutesAgendaRegister'],
  ['minutesAgendaDetail'],
  ['leaveOfAbsence', 'register']
]



// WEBPACK FOOTER //
// ./src/store/utils/app_whitelist.js